import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { obtenirDocument, telechargerFichier } from '../../App_Code/API';
import { toDate } from '../../App_Code/Utils';
import ModeCommunication from '../../App_Data/ModeCommunication';
import EtatCommunication from '../../App_Data/EtatCommunication';
import { verificationLocationState } from '../CaptureErreurs';
import Card from '../Card';
import Tableau from '../Tableau';

const MODE_AR = 2;
const LIEN_SUIVI_LAPOSTE = 'http://www.csuivi.courrier.laposte.fr/suivi/index';

const LigneComm = ({
    DateCom, ModeCom, NomInd2, RefCom, EtatCom,
}) => {
    const modeCom = ModeCommunication(ModeCom);
    const etatCom = EtatCommunication(EtatCom);

    return (
        <tr>
            <th>{toDate(DateCom, 'LLL')}</th>
            <td>
                <i className={modeCom.Icone} /> {modeCom.Type}
            </td>
            <td>{NomInd2}</td>
            <td>{RefCom}</td>
            <td className={etatCom.Couleur}>
                <i className={etatCom.Icone} /> {etatCom.Type}
            </td>
        </tr>
    );
};

const Communications = ({ LsComm }) => {
    const Entete = (
        <tr>
            <th scope="col">Date</th>
            <th scope="col">Type d&apos;envoi</th>
            <th scope="col">Destinataire</th>
            <th scope="col">Destination</th>
            <th scope="col">Statut</th>
        </tr>
    );

    const Lignes = LsComm.map((comm, i) => <LigneComm key={i} {...comm} />);

    return (
        <Card Titre="Communications">
            <Tableau Entete={Entete} Lignes={Lignes} />
        </Card>
    );
};

const LigneNumSuivi = ({ NumSuivi, Mode }) => (
    <div className="row mt-3">
        <div className="col-4">Numéro de suivi</div>
        <div className="col-4">
            <b className="text-primary">{NumSuivi}</b>
        </div>
        {Mode === MODE_AR && (
            <div className="col-4">
                <a
                    className="btn btn-outline-secondary"
                    target="_blank"
                    href={`${LIEN_SUIVI_LAPOSTE}?id=${NumSuivi}`}
                    role="button"
                    aria-disabled={Mode !== MODE_AR}
                >
                    <i className="fa fas fa-eye" /> Suivi
                </a>
            </div>
        )}
    </div>
);

const LigneTelechargement = ({ Nom, Token }) => (
    <div className="row mt-3">
        <div className="col-4">{Nom}</div>
        <div className="col-4">
            <a className="btn btn-outline-primary" target="_blank" href={telechargerFichier(Token)}>
                <i className="fa fas fa-download" /> Télécharger
            </a>
        </div>
        <div className="col-4">
            <Link
                to={{
                    pathname: '/MesDocuments/Document',
                    state: { Token },
                }}
                className="btn btn-outline-secondary"
            >
                <i className="fa fas fa-eye" /> Voir
            </Link>
        </div>
    </div>
);

const Suivi = ({ Titre, Mode, LsSuivi }) => {
    const {
        NumSuivi, PreuveDepot, PreuveEnvoi, AvisReception,
    } = LsSuivi;

    return (
        <Card Titre={Titre}>
            {NumSuivi && <LigneNumSuivi NumSuivi={NumSuivi} Mode={Mode} />}
            {PreuveDepot && <LigneTelechargement Nom="Preuve de dépôt" Token={PreuveDepot.Token} />}
            {PreuveEnvoi && <LigneTelechargement Nom="Preuve d'envoi" Token={PreuveEnvoi.Token} />}
            {AvisReception && <LigneTelechargement Nom="Avis de réception" Token={AvisReception.Token} />}
        </Card>
    );
};

class PageSuiviCourrier extends Component {
    state = {
        charge: false,
    };

    componentDidMount() {
        const { Id } = this.props.location.state;
        obtenirDocument(Id).then((data) => {
            if (data && (data.LsComm || data.LsSuivi)) {
                this.setState({
                    charge: true,
                    Mode: data.Mode,
                    LsComm: data.LsComm || null,
                    LsSuivi: data.LsSuivi || null,
                });
            }
        });
    }

    render() {
        if (!this.state.charge) return null;

        return (
            <div className="SuiviCourrier">
                <div className="row">
                    <div className="col-lg-12 col-xl">
                        {this.state.LsComm && <Communications LsComm={this.state.LsComm} />}
                    </div>
                    {this.state.LsSuivi && (
                        <div className="col-lg-12 col-xl-4">
                            <Suivi
                                Titre={this.props.location.state.TypeLib}
                                Mode={this.state.Mode}
                                LsSuivi={this.state.LsSuivi}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
PageSuiviCourrier.displayName = 'PageSuiviCourrier';
PageSuiviCourrier.requiredLocationState = [
    'Id', // Id du document à charger
];

export default verificationLocationState(PageSuiviCourrier);



// WEBPACK FOOTER //
// ./src/components/MesDocs/PageSuiviCourrier.js